import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TDashboardSlotItem, TDashboardSlotPayload } from "@/data/types";

/**
 * Get all dashboardSlots with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllDashboardSlots = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SLOTS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new dashboardSlot
 * @param params Request parameters
 * @param payload Create payload
 */
export const createDashboardSlot = (
  params: RequestParams,
  payload: TDashboardSlotPayload
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SLOTS.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a dashboardSlot by ID
 * @param dashboardSlotId The ID of the dashboardSlot to retrieve
 * @param params Request parameters
 */
export const getDashboardSlotById = (dashboardSlotId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SLOTS.BY_ID(dashboardSlotId),
    type: "GET",
    params,
  });
};

/**
 * Update a dashboardSlot by ID
 * @param dashboardSlotId The ID of the dashboardSlot to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateDashboardSlot = (
  dashboardSlotId: string,
  params: RequestParams,
  payload: Partial<TDashboardSlotPayload>
) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SLOTS.BY_ID(dashboardSlotId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a dashboardSlot by ID
 * @param dashboardSlotId The ID of the dashboardSlot to delete
 * @param params Request parameters
 */
export const deleteDashboardSlot = (dashboardSlotId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARD_SLOTS.BY_ID(dashboardSlotId),
    type: "DELETE",
    params,
  });
};